import { useLazyQuery } from '@apollo/client';

import GetSalesOrderByBillingCyclesDetailsQuery from '@/graphql/contracts/salesOrderByBillingCyclesDetails.query.gql';
import GetSalesOrderDetailsQuery from '@/graphql/contracts/salesOrderDetails.query.gql';
import { SalesOrderDetailsByBillingCycles, SalesOrderDetailsByBillingCyclesVariables } 
  from '@/graphql/contracts/_generated_/salesOrderByBillingCyclesDetails.query';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { SalesOrderDetails, SalesOrderDetailsVariables } from '@/graphql/contracts/_generated_/salesOrderDetails.query';

export interface SODetails {
  salesOrderId: string;
  contractNumbers: string;
  contractClientDatabaseReference?: string | null;
  consolidationFlag: boolean;
  salesOrderStatus: string;
  statusMessage?: string | null;
  payload: string;
  __typename: string;
}

interface SODetailsResponse {
  isLoading: boolean;
  soDetails?: SODetails;
}

export default function useGetSODetails() {

  const [_getSODetails] = useLazyQuery<SalesOrderDetails, SalesOrderDetailsVariables>(
    GetSalesOrderDetailsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
    },
  );

  const [_getSOBCDetails] = useLazyQuery<
  SalesOrderDetailsByBillingCycles,
  SalesOrderDetailsByBillingCyclesVariables
  >(GetSalesOrderByBillingCyclesDetailsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
  });

  const getSODetails = async (
    salesOrderId: string,
    isBillingCyclesPath: boolean,
  ): Promise<SODetailsResponse> => {
    const response = isBillingCyclesPath
      ? await _getSOBCDetails({
        variables: { salesOrderId: salesOrderId },
      })
      : await _getSODetails({
        variables: { salesOrderId: salesOrderId },
      });
    return {
      isLoading: response.loading,
      soDetails: (isBillingCyclesPath
        ? (response.data as SalesOrderDetailsByBillingCycles)?.salesOrderByBillingCyclesDetails
        : (response.data as SalesOrderDetails)?.salesOrderDetails) as SODetails,
    };
  };

  return {
    getSODetails,
  };
}
